import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';

import { DsSwitch } from '@frontend/ui/switch';
import { CommonMessages, HtmlNode } from '@frontend/vanilla/core';
import { AccountMenuDataService } from '@frontend/vanilla/shared/account-menu';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';

/**
 * @stable
 */
@Component({
    imports: [DsSwitch],
    selector: 'vn-dark-mode',
    templateUrl: 'dark-mode.html',
})
export class DarkModeComponent implements OnInit {
    @Output() readonly onChange = new EventEmitter<boolean>();

    readonly content = inject(CommonMessages);
    readonly service = inject(DarkModeService);
    private readonly accountMenuDataService = inject(AccountMenuDataService);
    private readonly htmlNode = inject(HtmlNode);

    ngOnInit() {
        if (this.accountMenuDataService.version() === 3) {
            this.htmlNode.setCssClass('navigation-layout-page-card', true);
        }
    }

    toggleDarkMode() {
        this.onChange.emit(!this.service.isEnabled);
        this.service.toggle();
    }
}
